type LockOpenIconProps = {
  fillColor: string;
  size?: number;
};

export default function LockOpenIcon({
  fillColor,
  size = 24,
}: LockOpenIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 20H18V10H6V20ZM12 17C12.55 17 13.0208 16.8042 13.4125 16.4125C13.8042 16.0208 14 15.55 14 15C14 14.45 13.8042 13.9792 13.4125 13.5875C13.0208 13.1958 12.55 13 12 13C11.45 13 10.9792 13.1958 10.5875 13.5875C10.1958 13.9792 10 14.45 10 15C10 15.55 10.1958 16.0208 10.5875 16.4125C10.9792 16.8042 11.45 17 12 17ZM6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V10C4 9.45 4.19583 8.97917 4.5875 8.5875C4.97917 8.19583 5.45 8 6 8H13V6C13 4.61667 13.4875 3.4375 14.4625 2.4625C15.4375 1.4875 16.6167 1 18 1C19.3833 1 20.5625 1.4875 21.5375 2.4625C22.5125 3.4375 23 4.61667 23 6H21C21 5.16667 20.7083 4.45833 20.125 3.875C19.5417 3.29167 18.8333 3 18 3C17.1667 3 16.4583 3.29167 15.875 3.875C15.2917 4.45833 15 5.16667 15 6V8H18C18.55 8 19.0208 8.19583 19.4125 8.5875C19.8042 8.97917 20 9.45 20 10V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6Z"
        fill={fillColor}
      />
    </svg>
  );
}
